<template>
  <div
    class="export_config"
    :class="{justBtn:justBtn}"
  >
    <!-- 弹窗 -->
    <el-popover
      :placement="position"
      :width="width"
      trigger="click"
    >
      <!-- 按钮 -->
      <el-button
        slot="reference"
        type="primary"
        :style="{float: btnFloat}"
        class="export"
      >
        {{ btnName }}
      </el-button>
      <!-- 选项卡 -->
      <el-checkbox
        v-model="checkAll"
        class="select_all"
        :indeterminate="isIndeterminate"
        @change="handleCheckAllChange"
      >
        全选
      </el-checkbox>
      <el-checkbox-group
        v-model="selected"
        @change="singleCheck"
      >
        <el-checkbox
          v-for="(item, index) in allHead"
          :key="index"
          :label="item.fieldLabel"
          class="export_config_check_label"
        >
          {{ item.fieldLabel }}
        </el-checkbox>
      </el-checkbox-group>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'ExportConfig',
  props: {
    allHead: { // 表格表头
      type: Array,
      required: true
    },
    btnName: { // 按钮名字
      type: String,
      default: '配置'
    },
    headerName: { // 表名
      type: String,
      required: true
    },
    fieldLabel: { // 表头对象的中文名，以防不同的导出接口有不同的key对应
      type: String,
      default: 'fieldLabel'
    },
    // 布局配置
    boxFloat: { // 外层盒子设置浮动，配合 justBtn = true
      type: String,
      default: 'right'
    },
    justBtn: { // 忽略外层元素，只留一个button，用于详情页  false 为单独一行
      type: Boolean,
      default: true,
    },
    btnFloat: { // 按钮位置 - 独占一行时按钮浮动位置
      type: String,
      default: 'right'
    },
    width: { // 选项卡宽度
      type: String,
      default: '180'
    },
    position: { // 选项卡位置
      type: String,
      default: 'left'
    },
  },
  data () {
    return {
      checkAll: false, // 是否全选
      selected: [], // 已勾选的表头
      keyList: [], // 存放全表头的 fieldLabel 值， 全选用

      isIndeterminate: true, // 全选框有三种样式，全选，部分选，全不选。isIndeterminate用来表明部分选择  样式为横杠 -

    }
  },
  mounted () {
    this.initVisiableSelect() // 初始化可选表头
    this.initHisSelect() // 勾选历史表头
  },
  methods: {
    /**
       * 储存的时候需要把 name 和 key 一起储存，导出时直接读取 store 的数据，所以在存入时要根据 selected 匹配，把对应的 key 存起来
       *
       * 初始化的时候 只 name，所以需要遍历提取 name
       *
       * 导出的时候 1、直接使用 store 里对应的 header 2、进行本地储存
       */
    // 初始化可勾选表头
    initVisiableSelect () {
      // 提取表头中文名，用于配置可勾选表头
      this.allHead.forEach(item => {
        this.keyList.push(item[this.fieldLabel])
      })
    },
    // 初始化历史勾选表头
    initHisSelect () {
      let arr = this.$store.state.exportConfig.hisHeader[this.headerName] || [] // 赋值
      arr.forEach(item => {
        this.selected.push(item[this.fieldLabel])
      })
      if (this.selected.length === 0 || this.selected.length === this.keyList.length) { // 上次为全选和全不选  进来时都变成全选
        this.selected = this.keyList // 全选
        this.checkAll = true // 全选样式
        this.isIndeterminate = false // 非部分勾选
        this.setStore()
      }
    },
    // 单选
    singleCheck (value) { // 每次勾选触发 singleCheck
      let checkedCount = value.length // 每次勾选后判断已勾选的长度
      this.checkAll = checkedCount === this.allHead.length // 判断当前是否为全选
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allHead.length // 改变全选框样式
      this.setStore()
    },
    // 全选
    handleCheckAllChange (boolean) { // boolean: true/false
      this.selected = boolean ? this.keyList : [] // 全选/全不选
      this.isIndeterminate = false // 改变部分选中状态为false
      this.setStore()
    },
    // 发起储存 - store 为中转站
    setStore () {
      // 储存前先按origin排序，不然导出的顺序不符合业务要求
      let selectedList = []
      this.keyList.forEach((item, index) => {
        let check = this.selected.findIndex((i) => {
          return item === i
        })
        if (check !== -1) {
          selectedList.push(this.allHead[index])
        }
      })
      // 配置发送的参数
      let param = {
        name: this.headerName,
        value: selectedList
      }
      this.$store.commit('setHeader', param)
    },
  }

}

</script>

<style lang="scss" scoped>
  .export_config_check_label {
    display: block;
    margin: 0px !important;
  }

  .export_config {
    height: 34px;
    line-height: 34px;
  }

  .select_all {
    // 全选按钮
    margin-bottom: 15px;
  }

  .justBtn {
    display: inline;

    button {
      float: none !important;
      margin-left: 10px;
    }
  }

  .export {
    color: #606266;
    border-color: #dcdfe6;
    height: 32px;
    padding: 0 20px;
    font-size: 15px;
    border-radius: 4px;
    width: 74px;
    background-color: white;
  }

  .export:active,
  .export:hover {
    background-color: rgb(254, 248, 237);
    border-color: rgb(253, 235, 200);
    color: rgb(251, 210, 108)
  }

</style>
